// status-webapp/src/api/runs.ts
import { apiFetch } from "./client";
import type { Run } from "@/types";

export async function listRuns(): Promise<Run[]> { return apiFetch("/api/runs"); }
export async function getRun(id: string): Promise<Run> { return apiFetch(`/api/runs/${id}`); }

export async function createRun(body: {
  release: string; stages: string[];
  scope?: Record<string, any>;
  triggered_by: string; description?: string;
}): Promise<Run> {
  return apiFetch("/api/runs", { method: "POST", body: JSON.stringify(body) });
}
